// extracted by mini-css-extract-plugin
module.exports = {"lia-khoros-svg":"KhorosLogo_lia-khoros-svg__Vn459"};